import kleur from 'kleur'

export const cliColors = {
    primary: kleur.cyan,
    secondary: kleur.magenta,
    accent: kleur.magenta,

    success: kleur.green,
    warning: kleur.yellow,
    danger: kleur.red,
    info: kleur.blue,
    muted: kleur.gray,
    dark: kleur.black,
    light: kleur.white,
}

export { kleur }
